module.exports = __webpack_public_path__ + "web_static/img/blue_arrow_gif.f58f7b78.gif";